"use client";

import { FC, useState } from "react";
import BFLModal from "@repo/shared-ui/BFLModal";
import useModalCloseOnBrowserButton from "@repo/shared-utils/useModalCloseOnBrowserButton";
import {
  SCHEME_TERMS,
  SCHEME_TERMS_BUTTON_TEXT,
  SCHEME_TERMS_CTA_LABEL,
  SCHEME_TERMS_MODAL_TITLE,
  SchemeTerm,
} from "./AboutFundSchemeTermsConstants";

interface AboutFundSchemeTermsProps {
  learnAboutTermsCta?: string;
  schemeTermsModalTitle?: string;
  schemeTermsCtaText?: string;
  schemeTerms?: SchemeTerm[];
}

const AboutFundSchemeTerms: FC<AboutFundSchemeTermsProps> = ({
  learnAboutTermsCta,
  schemeTermsModalTitle,
  schemeTermsCtaText,
  schemeTerms,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const ctaLabel = learnAboutTermsCta || SCHEME_TERMS_CTA_LABEL;
  const modalTitle = schemeTermsModalTitle || SCHEME_TERMS_MODAL_TITLE;
  const buttonText = schemeTermsCtaText || SCHEME_TERMS_BUTTON_TEXT;
  const terms = schemeTerms?.length ? schemeTerms : SCHEME_TERMS;

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  useModalCloseOnBrowserButton(isModalOpen, handleClose, { requireInApp: false });

  return (
    <div className="mt-3">
      <button
        type="button"
        className="text-link-primary flex cursor-pointer items-center gap-1 text-sm font-normal italic"
        onClick={handleOpen}
        aria-label={ctaLabel}
      >
        <span>{ctaLabel}</span>
        <i className="icomoon text-xs before:content-['\e907']" aria-hidden="true" />
      </button>

      <BFLModal
        isOpen={isModalOpen}
        onClose={handleClose}
        title={modalTitle}
        enableScroll={false}
        modalClassName="flex h-[519px] max-h-[calc(100vh-24px)] w-full max-w-[540px] flex-col overflow-hidden rounded-[8px] lg:!max-w-[540px]"
        bodyClassName="flex min-h-0 flex-1 flex-col overflow-hidden"
      >
        <div className="no-scrollbar flex min-h-0 flex-1 [scrollbar-width:none] flex-col gap-5 overflow-y-auto text-sm text-gray-700 [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {terms.map((term, index) => (
            <div key={`${term.title}-${index}`}>
              <p className="font-medium text-gray-900">{term.title}</p>
              <p className="mt-1">{term.description}</p>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={handleClose}
          className="mt-4 w-full shrink-0 cursor-pointer rounded-[200px] bg-[var(--primary-action-primary,#FF6700)] py-[11px] text-sm leading-[18px] font-medium text-white uppercase transition-all duration-300 ease-in-out hover:opacity-90"
        >
          {buttonText}
        </button>
      </BFLModal>
    </div>
  );
};

export default AboutFundSchemeTerms;
